import React from "react";
import logo from "../../assets/logo.png";
import smallX from "../../assets/small-x.png";
import linkedin from "../../assets/s-linkedin.png";
import instagram from "../../assets/s-instagram.png";
import facebook from "../../assets/s-facebook.png";
import tick from "../../assets/s-tick.png";
import "./footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const cat = [
    {
      title: "Residential",
      link: "/residential",
    },
    {
      title: "Commercial",
      link: "/commercial",
    },
    {
      title: "Landlord",
      link: "/agents",
    },
    {
      title: "Developers",
      link: "/developers",
    },
  ];
  const links = ["Blog", "About us", "Terms & Conditions", "Privacy Policy"];

  return (
    <footer className="footer">
      <div className="footer-top">
        <Link to={"/"} style={{ textDecoration: "none" }}>
          <img src={logo} alt="logo" />
        </Link>
        <div className="footer-top_text">
          <div className="footer-top_text-left">
            <p>
              Are you a tenant, landlord, real estate agent, or developer
              looking for a smarter way to manage properties, close deals, and
              stay organized? Look no further—PrimeProperty is here to
              revolutionize the real estate experience for everyone involved.
            </p>
          </div>
          <div className="footer-top_text-right">
            <div className="footer-contact">
              <h3>Contact us</h3>
              <p>TEhub building opposite RCCG Mega Parish, Akure, Nigeria</p>
              <div className="footer-contact_num">
                <p>+234 8168206494</p>
              </div>
              <p>support@primeproperty.ng</p>
            </div>
            <div className="footer-cat footer-contact">
              <h3>Categories</h3>
              <div className="cat-cont">
                {cat.map((item, i) => {
                  return (
                    <Link
                      key={i}
                      to={item.link}
                      style={{ textDecoration: "none" }}
                    >
                      <div className="each-cat">
                        <p>{item.title}</p>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
            <div className="footer-links footer-contact">
              <h3>Links</h3>
              <div className="cat-cont">
                {links.map((item, i) => {
                  return (
                    <div key={i} className="each-cat">
                      <p>{item}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-btm">
        <div className="footer-btm_right">
          <p>&copy; 2025 All rights reserved.</p>
        </div>
        <div className="footer-btm_left">
          <p>Follow us for updates</p>
          <a
            href="http://tiktok.com/@primepropertyng"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={tick} alt="icon" />
          </a>

          <a
            href="http://instagram.com/primepropertyng"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="icon" />
          </a>

          <a
            href="https://www.facebook.com/Artisanmarket247"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={facebook} alt="icon" />
          </a>
          <img src={linkedin} alt="icon" />

          <a
            href="http://x.com/primepropertyyy"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={smallX} alt="icon" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
